export default __webpack_public_path__ + "static/media/payment-plan-deposit-two-one.9b3e484b.png";